import { UserRole } from "../constants";
import MainMedicalStaffSelector from "./MainMedicalStaffSelector";

/**
 * Listado de centros médicos con su anticipo
 */
export default function MedicalStaffSelector() {
  const role = localStorage.getItem("role");

  if (role === UserRole.MEDICAL_CENTER) {
    return <MainMedicalStaffSelector />;
  }
}
